<header *ngIf="isShowHeader" class="header">
  <h1 style="margin-left: 12px;">
    <img
      class="logo-image"
      [src]="logoUrl1"
      width="110"
      height="20"
      style="margin-bottom: 8px;"
      alt="SgzpMaster"
    />
    <img
      class="logo-image"
      [src]="logoUrl2"
      width="194"
      height="20"
      alt="SgzpMaster"
    />
  </h1>
</header>

<div class="container">
  <div data-app="true" class="v-application v-application--is-ltr theme--light main">
    <div class="v-application--wrap">
      <div class="inner">
        <h1 class="text-center mb-10">ログイン</h1>
        <div
          class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
          style="display: flex; justify-content: center; width: 550px"
        >
          <div class="v-input__control">
            <label for="email" class="bold">メールアドレス</label>
            <div class="v-input__slot">
              <input
                style="height: 100%"
                (focus)="focus(inputState.email)"
                (blur)="blur(inputState.email)"
                [(ngModel)]="email"
                id="email"
                type="email"
              />
            </div>
            <div class="v-text-field__details">
              <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
              <div class="v-messages theme--light error--text">
                <div
                  *ngIf="errorMessages.login.email"
                  class="v-messages__wrapper"
                >
                  {{ errorMessages.login.email }}

                  <!-- 注釈及びエラーテキストが入ります。 -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- focus時 class="v-input ..." に v-input--is-focused、primary--text を追加 ↓ -->
        <!-- エラー時 class="v-input ..." に v-input--has-state、error--text を追加 ↓ -->
        <div
          class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
          style="display: flex; justify-content: center; width: 550px"
        >
          <div class="v-input__control">
            <label for="password" class="bold">パスワード</label>
            <app-sgzp-master-password-input
              [(ngModel)]="password"
              name="confirm"
              placeholder="パスワード（再入力）"
            ></app-sgzp-master-password-input>
            <div class="v-text-field__details">
              <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
              <div class="v-messages theme--light error--text">
                <div
                  *ngIf="errorMessages.login.password"
                  class="v-messages__wrapper"
                >
                  {{ errorMessages.login.password }}
                </div>
              </div>
            </div>
          </div>
        </div>


        <label class="agreement d-flex align-start mt-6 mb-3">
          <!-- TODO margin-topじゃない自動レイアウト -->
          <div
            style="margin-top: 5px"
            class="v-input v-input--is-focused theme--light v-input--selection-controls v-input--checkbox"
            (click)="checkIsEmailSave()"
          >
            <div class="v-input__control">
              <div style="height: 32px; align-items: center">
                <div
                  class="v-input--selection-controls__input primary--text"
                >
                  <i
                    aria-hidden="true"
                    [class]="isEmailSaveCheckedStyle.i"
                  ></i
                  ><input
                    [(ngModel)]="isSaveEmail"
                    aria-checked="true"
                    id="input-32"
                    role="checkbox"
                    type="checkbox"
                    value=""
                  />
                  <div [class]="isEmailSaveCheckedStyle.div"></div>
                </div>
              </div>
            </div>
          </div>
          <span class="text-gray600"
            >ログイン情報を保存する</span
          ></label
        >
        <div class="text-center mb-6"
        style="display: flex; justify-content: center; width: 550px; width: 100%">
          <button
            (click)="login()"
            type="button"
            class="v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary full-width"
            medium=""
          >
            <span class="v-btn__content"> ログイン </span>
          </button>
        </div>
        
        <div
        class="mb-6"
        style="
          display: flex;
          justify-content: start;
          align-items: baseline;
        "
      >
        <a
          (click)="navigateCportal('forgot-password')"
          class="text-link text-link-underline v-text-caption-forgot-password bold"
        >
          パスワードを忘れた方はこちら
        </a>
      </div>
      </div>
    </div>
  </div>
</div>
